import React, { useState, useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Card from "olive-react-myoneui/lib/Card";
import Tab from "olive-react-myoneui/lib/Tab";
import Nav from "olive-react-myoneui/lib/Nav";
import ApprenticeshipCarousel from "./ApprenticeshipCarousel";
import MyCoursesCarousel from "./MyCourseCarousel";
import Button from "olive-react-myoneui/lib/Button";
import ModalCommon from '../ModalCommon';
import { cartIcon, certificateIcon, certiIcon, pieIcon } from "../../../constants/icons";
import LearningProgress from '../card/LearningProgress';
import AchievementsCounter from '../card/AchievementsCounter';
import NoItemsInfo from "../../../student-dashboard/NoItemsInfo";
import { pluralize } from '../../../../helpers/string_helper';
import { CourseItemLoader } from '../../Loader';
import { setConfigData } from '../../../../reducers/configSlice';
import { checkDisabledSp } from '../../../../helpers/permission_helper';

function CoursesApprenticeshipTabs({ className, courses, showCourseViewAllBtn, hasCourses, hideApprenticeship, apprenticeshipList,  showApprenticeShipViewAllBtn, isLoading, courseStatusCounts, apprenticeshipStatusCounts, certificateCounts }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);
	const navigate = useNavigate();

  const [showCertModal, setShowCertModal] = useState(false);

  const handleCloseModalCert = () => setShowCertModal(false);
  const handleShowCertModal = () => setShowCertModal(true);
  const [enrolledCourses, setEnrolledCourses] = useState(courses);
  const [showViewAllBtn, setShowViewAllBtn] = useState(showCourseViewAllBtn);
  const [hasEnrolledCourses, setHasEnrolledCourses] = useState(hasCourses);
  const dispatch = useDispatch();

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  const adminData = useSelector((state) => state.admin);
  const configData = useSelector((state) => state.config);
  if(checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) && !hideApprenticeship) {
    dispatch(setConfigData({active_sp_enrollment: 'apprenticeship'}));
  }else if(!checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) && hasEnrolledCourses){
    dispatch(setConfigData({active_sp_enrollment: 'course'}));
  }else if(!checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) && !hasEnrolledCourses) {
    dispatch(setConfigData({active_sp_enrollment: 'apprenticeship'}));
  } else {
    dispatch(setConfigData({active_sp_enrollment: ''}));
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const clickViewAll = (e) => {
    e.preventDefault();
    const url = `/student-dashboard/` + (hasEnrolledCourses ? 'courses' : 'apprenticeship');
    navigate(url);
  }

  const changeCourseState = (tab) => {
    setHasEnrolledCourses(tab === 'course' ? true : false);
    dispatch(setConfigData({active_sp_enrollment: tab}));
  }

  useEffect(()=>{
    setEnrolledCourses(courses);
    setShowViewAllBtn(showCourseViewAllBtn);
    setHasEnrolledCourses(hasCourses);
  },[courses]);

  useEffect(() => {
  }, [enrolledCourses]);


  if(checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) && hideApprenticeship) {
    return (
      <Card className="myk__stu-sp-disabled course-tabs-carousel border-0 mb-0 bg-transparent">
        <Card.Body className="p-0 pb-0">
          <div class=" empty-block-card card">
            <div class="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center card-body">
              <div class="empty-block">
                <h6><strong>Service Providers Disabled!</strong></h6>
                <p>Service Providers are currently disabled, please contact administrator.</p>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }
  return (
    <Card className="course-tabs-carousel border-0 mb-0 bg-transparent">
      <Card.Body className="p-0 pb-0">
        <Tab.Container id="left-tabs-example" defaultActiveKey={checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) ? 'apprenticeship' : 'enrolledcourses'}>
          <div className="myk__courses-tabs_actions-wrapper d-flex gap-2 justify-content-between">
            <Nav variant="pills" className="p-0">
              {
                !checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) &&
                <Nav.Item>
                  <Nav.Link eventKey="enrolledcourses" onClick={enrolledCourses && enrolledCourses.length > 0 ? () => changeCourseState('course') : null}>My Enrolled Courses</Nav.Link>
                </Nav.Item>
              }
              <Nav.Item>
                {hideApprenticeship !== '' && hideApprenticeship === false && (
                <Nav.Link eventKey="apprenticeship" onClick={() => changeCourseState('apprenticeship')}>My Apprenticeship Programs</Nav.Link>
                )}
              </Nav.Item>
            </Nav>
            <div className="myk__courses-tabs-actions d-flex gap-2">
            {screenWidth <= 1368 && (
              <>
                <Button variant="outline" className="btn-piechart-pop bg-white border-0 py-2" onClick={handleShowModal}>{pieIcon}</Button>
                <Button variant="outline" className="btn-certi-pop bg-white border-0 py-2" onClick={handleShowCertModal}>{certiIcon}</Button>
              </>
            )}
            {(hasEnrolledCourses && showViewAllBtn) ? 
              (<Button variant="outline" className="bg-transparent py-1" onClick={clickViewAll}>View All</Button>) : ('')
            }
            </div>
          </div>
          <Tab.Content>
            { !checkDisabledSp('mykademy', adminData.products, adminData.user_sp_enabled) &&
              <Tab.Pane
                eventKey="enrolledcourses"
                className="bg-transparent ps-0 pb-3"
              >
                {isLoading === true ? 
                (<CourseItemLoader items={2} /> ):
                isLoading === false && hasEnrolledCourses === true ?
                (<MyCoursesCarousel courses={enrolledCourses} isLoading={isLoading} />) : 
                isLoading === false && hasEnrolledCourses === false ? 
                (<NoItemsInfo itemType='course' />) : ('')
                }
              </Tab.Pane>
            }
            <Tab.Pane
              eventKey="apprenticeship"
              className="bg-transparent ps-0 pb-3"
            >
              {hideApprenticeship !== '' && hideApprenticeship === false && apprenticeshipList.length > 0 ? (<ApprenticeshipCarousel apprenticeshipList={ apprenticeshipList } />)
              : hideApprenticeship === false && apprenticeshipList.length === 0 ? (<NoItemsInfo itemType='apprenticeship'/>) : '' }
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
        <ModalCommon
          show={showModal}
          onClose={handleCloseModal}
          title="My Enrollment Progress"
        >
          <LearningProgress courseStatusCounts={courseStatusCounts} apprenticeshipStatusCounts={apprenticeshipStatusCounts}/>
        </ModalCommon>

        <ModalCommon
          show={showCertModal}
          onClose={handleCloseModalCert}
          title="My Certificate"
        >
          <AchievementsCounter title={pluralize(certificateCounts,'Certificate')} certificateCounts={certificateCounts} />
        </ModalCommon>
      </Card.Body>
    </Card>
  );
}

export default CoursesApprenticeshipTabs;
